import { render, staticRenderFns } from "./BusinessCategorySelect.vue?vue&type=template&id=8c9b7bb4&scoped=true&"
import script from "./BusinessCategorySelect.vue?vue&type=script&lang=js&"
export * from "./BusinessCategorySelect.vue?vue&type=script&lang=js&"
import style0 from "./BusinessCategorySelect.vue?vue&type=style&index=0&id=8c9b7bb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c9b7bb4",
  null
  
)

export default component.exports